/* =========================================
   Footer PageTop
========================================= */

export function initFooterPagetop() {
  const pagetop = document.querySelector(".l-footer__pagetop");

  if (!pagetop) return;

  pagetop.addEventListener("click", (event) => {
    event.preventDefault();

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // スナップスクロールを一時停止
    window.dispatchEvent(new CustomEvent("snapScroll:disable"));

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });

    // スクロール完了後にスナップスクロールを再開
    const enableSnapScroll = () => {
      window.dispatchEvent(new CustomEvent("snapScroll:enable"));
      window.removeEventListener("scrollend", enableSnapScroll);
    };

    if ("onscrollend" in window) {
      window.addEventListener("scrollend", enableSnapScroll, {
        once: true,
      });
    } else {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("snapScroll:enable"));
      }, prefersReducedMotion ? 0 : 1000);
    }
  });
}